<script lang="ts">
  import { Badge,Progress } from "sveltestrap";
  import { gamestate } from "../stores";

  let sorted = [];
  let max = 0;

  let topics: {[key: string] : number} = {};
  $: topics = $gamestate.subscribers.reduce((topics, sub) => {
    for (let topic in sub.interests) {
      topics[topic] = topics[topic] || 0;
      topics[topic] += sub.interests[topic];
    }
    return topics;
  }, {});
  $: sorted = Object.entries(topics)
    .sort((a, b) => b[1] - a[1]);
  $: max = sorted.reduce((max, topic) => Math.max(max, topic[1]), 0);
</script>

<div>
  {#if sorted.length !== 0}
    <h4>Interests</h4>
    <table class="w-100">
      {#each sorted as [skill, value]}
        <tr>
          <th>
            <Badge color="secondary" class="w-100">{skill}</Badge>
          </th>
          <td class="w-100">
            <Progress class="ms-2" style="height: 1.25rem" striped color="secondary" max={max * 1000} value={value * 1000} />
          </td>
        </tr>
      {/each}
    </table>
  {/if}
</div>